// extracted by mini-css-extract-plugin
module.exports = {"windForecastContainer":"WindForecastContainer_windForecastContainer__rVmPL","forecastGraphWind":"WindForecastContainer_forecastGraphWind___bqEm"};